var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowLightImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 903,
    height: 724,
    viewBox: "0 0 903 724",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M902.234 349.997L521.407 322.426L507.621 322.426L0.999733 287.962L11.3389 396.523L343.917 370.675L33.7406 462.005L131.963 584.352L371.488 408.586L200.67 657.125L405.133 723.675L442.139 408.586L506.519 723.953L682.985 680.585L507.621 396.523L762.655 615.37L836.753 524.04L521.407 370.675L881.556 436.157L902.234 349.997Z",
    fill: "url(#paint0_radial_6222_20503)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02664 376.736L381.929 403.262L395.714 403.224L902.428 436.297L891.791 327.764L559.285 354.525L869.21 262.344L770.652 140.267L531.61 316.69L701.746 67.6833L497.1 1.69485L460.959 316.884L395.714 1.69487L219.367 45.5476L395.511 329.126L139.877 110.981L66.0303 202.514L381.796 355.012L21.4685 290.519L1.02664 376.736Z",
    fill: "url(#paint1_radial_6222_20503)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6222_20503",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(451.619 486.991) rotate(-90) scale(199.03 450.617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE37",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6222_20503",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(451.265 238.505) rotate(89.8427) scale(199.03 450.617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE37",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8AC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLightImg);
export default __webpack_public_path__ + "static/media/yellowLightImg.37f7da276981f6996da60c38539d8060.svg";
export { ForwardRef as ReactComponent };